export default {
  title: "新下单",
  baseUrl: {
    // dev: 'http://172.16.77.110:8709/', // 测试/
    // dev: 'http://127.0.0.1:8709/', // 测试/
    // dev: 'http://192.168.1.206:8709/', // 测试
    // dev: 'http://172.16.181.137:8709/', // 测试
    // dev: 'http://172.16.185.230:8709/', // 测试
    // dev: "https://www.smartmtm.com/api/",
    // dev: "https://smartmtm.com.cn/",
    dev: "https://www.smartmtm.com/api",
    // pro: '/api/'
  },
};



// WEBPACK FOOTER //
// ./src/config/index.js